import Resource from 'vue-resource';
import store from '../store/store';
import jwtService from '../services/jwt.service';
import router from '../router';
/**
 *
 */
export const interceptGuard = Vue => {
  Vue.use(Resource);
  if (process.env.NODE_ENV === 'development') {
    let token;

    switch (process.env.VUE_APP_SYSTEM) {
      case 'sun':
        token = process.env.VUE_APP_JWT_TOKEN_SUNR;
        break;
      case 'syscor':
        token = process.env.VUE_APP_JWT_TOKEN_SYSCOR;
        break;
      default:
        token = process.env.VUE_APP_JWT_TOKEN_SUNR;
        break;
    }

    window.localStorage.setItem('access_token', token);
    window.localStorage.setItem('revista.modulo', process.env.VUE_APP_SYSTEM);
    window.localStorage.setItem('revista.canal', process.env.VUE_APP_CANAL);
    if (process.env.VUE_APP_UF) {
      window.localStorage.setItem('revista.uf', process.env.VUE_APP_UF)
    }

    Vue.http.interceptors.push((request, next) => {
      request.headers.set('Authorization', `Bearer ${token}`);
      request.headers.set('Accept', 'application/json');
      next();
    });
  } else {
    Vue.http.interceptors.push((request, next) => {
      next(({ status, data }) => {
        if (status === 401 && data.error === 'invalid_credentials') {
          // window.localStorage.clear();]
          router.push('/login');
        } else if (status === 401 && data.error === 'token_expired') {
          if (!store.getters['idle/status']) {
            return jwtService.refreshToken().then(() => Vue.http(request).then(data => data));
          }
          // window.localStorage.clear();
          router.push('/login');
        }
      });
    });
  }
};
